export const cards = [
  {
    no: "01",
    kicker: "Build",
    title: "A/B Testing\nBuilder",
    desc: "Test multiple variants side by side. Spin up A/B/C/D in minutes — different hooks, formats, durations, or angles. Imagive splits the audience, runs the test, and tracks every variant in one dashboard.",
    rows: [
      {
        title: "Multi-variant builder",
        desc: "Up to 8 variants per cell — hook, body, CTA, format. Auto-balanced audience splits keep results fair.",
      },
      {
        title: "Smart test templates",
        desc: "Pre-built recipes for hook tests, format tests, length tests — pulled from what's winning in your category.",
      },
      {
        title: "Live performance tracking",
        desc: "Watch ROAS, CTR, TSR diverge in real time — kill underperformers without waiting for the test window to close.",
      },
    ],
    cta: "Build your first test",
  },
  {
    no: "02",
    kicker: "Refine",
    title: "Copy\nOptimizer",
    desc: "Paste any ad copy. Imagive rewrites it for clarity, tightens the hook, matches your brand tone, and predicts the lift — every suggestion scored against winning creatives in your category.",
    rows: [
      {
        title: "One-click rewrites",
        desc: "Tighten verbose copy, sharpen weak hooks, or generate alternative angles — each with predicted impact scoring.",
      },
      {
        title: "Tone matching",
        desc: "Lock to your brand voice — bold, warm, playful, premium — and every suggestion stays on tone, every time.",
      },
      {
        title: "Performance-graded",
        desc: "Every rewrite scored on clarity, hook strength, and predicted lift — see the gain before you ship.",
      },
    ],
    cta: "Optimize a piece of copy",
  },
  {
    no: "03",
    kicker: "Score",
    title: "Hook\nScorer",
    desc: "Drop in 5, 10, or 50 hooks. Imagive ranks each by predicted Thumb Stop Rate — the share of viewers likely to stop scrolling in the first 3 seconds — so you only run the ones that earn the click.",
    rows: [
      {
        title: "Predicted Thumb Stop Rate",
        desc: "Trained on millions of live ads. 25%+ is good, 40%+ is elite.",
      },
      {
        title: "Hook archetype detection",
        desc: "Each hook is tagged — question, bold claim, story, discount, contradiction — so you know your angle mix at a glance.",
      },
      {
        title: "Bulk scoring",
        desc: "Paste 50 hooks at once, get back a ranked list in seconds — perfect for narrowing a brainstorm.",
      },
    ],
    cta: "Score a hook",
  },
  {
    no: "04",
    kicker: "Declare",
    title: "Winner\nDetector",
    desc: "Imagive watches every running test, runs continuous statistical checks, and surfaces the winner the moment confidence crosses 90% — often days before manual analysis would.",
    rows: [
      {
        title: "Statistical confidence detection",
        desc: "Continuous Bayesian checks against the control. Winner declared at 90% confidence with a clear “ship it” callout.",
      },
      {
        title: "Auto-kill underperformers",
        desc: "Variants falling below the loser threshold are auto-paused — saving spend for variants with a path to winning.",
      },
      {
        title: "Win-rate trend",
        desc: "Track New Creative Win Rate over time — the single best signal a testing operation is healthy. Elite teams hit 20–30%.",
      },
    ],
    cta: "See your active tests",
  },
];
